<template>
  <v-dialog v-model="dialog" max-width="800">
    <ValidationObserver ref="createPriceForm" v-slot="{ invalid, passes }">
      <form
        rel="createPriceForm"
        class="flex flex-wrap justify-between sm:justify-center"
        @submit.prevent="passes(submit)"
      >
        <v-card>
          <v-card-title class="pa-7"> Nový ceník </v-card-title>
          <v-skeleton-loader :loading="loading" :types="skeleton" type="article, actions">
            <v-card-text class="pa-7">
              <v-row>
                <v-col cols="12" sm="4" class="py-0">
                  <VDatePickerWithValidation
                    v-model="validSince"
                    date-format="dd.MM.yyyy"
                    rules="required"
                    outlined
                    dense
                    label="Platnost od"
                  />
                </v-col>
              </v-row>
              <v-row v-for="distributor in distributorPrices.distributors" :key="distributor.id">
                <v-col cols="12" class="mb-6">
                  <div class="mb-10 pa-2" style="background-color: black">
                    <h2 class="white--text">{{ distributor.name.toUpperCase() }}</h2>
                  </div>
                  <v-row
                    v-for="rate in distributor.ranges"
                    :key="rate.id"
                    align="center"
                    justify="center"
                  >
                    <v-col cols="12" sm="4" class="py-0 px-5 pb-3 pa-3">
                      <H3>{{ rate.range }}</H3>
                    </v-col>
                    <v-col cols="12" sm="4" class="py-0 px-5 pb-3 pa-3">
                      <VTextFieldWithValidation
                        v-model="rate.price"
                        rules="required"
                        outlined
                        type="number"
                        dense
                        label="Cena"
                        :hide-messages="true"
                      />
                    </v-col>
                    <v-col cols="12" sm="4" class="py-0 px-5 pb-3 pa-3">
                      <VTextFieldWithValidation
                        v-model="rate.priceFixedSalary"
                        rules="required"
                        outlined
                        type="number"
                        dense
                        label="Cena SP"
                        :hide-messages="true"
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="pl-7 pr-7 pb-7">
              <v-spacer></v-spacer>
              <v-btn
                type="submit"
                height="40px"
                min-width="130px"
                color="primary"
                depressed
                :loading="saving"
              >
                Uložit
              </v-btn>
            </v-card-actions>
          </v-skeleton-loader>
        </v-card>
      </form>
    </ValidationObserver>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import VDatePickerWithValidation from '../validators/VDatePickerWithValidation'
import formatDate from '@/utils/formatDate'

export default {
  name: 'SupplierGasProductPricesAddDialog',
  components: { VDatePickerWithValidation },
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
      distributors: [],
      ranges: [],
      validSince: null,
      distributorPrices: {
        validSince: null,
        distributors: [],
      },
      distributorLoading: false,
      rangesLoading: false,
      saving: false,
      dialog: false,
    }
  },
  computed: {
    loading() {
      return this.distributorLoading || this.rangesLoading
    },
  },
  watch: {
    validSince: {
      handler() {
        this.distributorPrices.validSince = formatDate(this.validSince)
      },
    },
  },
  created() {
    const model = this
    this.$eventBus.$on('supplierGasProductPricesAddDialog', function (dialog) {
      model.validSince = null
      model.distributorPrices.validSince = null
      model.distributorPrices.distributors = []
      model.createDistributorRangeForm()
      model.dialog = dialog
    })
    this.loadDistributors()
  },
  methods: {
    ...mapActions({
      searchDistributor: 'gas/searchDistributor',
      getRanges: 'gas/getRanges',
      createSupplierProductPrice: 'supplier/createSupplierProductPrice',
    }),
    loadDistributors() {
      this.distributorLoading = true
      this.searchDistributor()
        .then((response) => {
          this.distributors = response.data.items
          this.loadRanges()
        })
        .finally(() => {
          this.distributorLoading = false
        })
    },
    loadRanges() {
      this.rangesLoading = true
      this.getRanges()
        .then((response) => {
          this.ranges = response.data
          this.createDistributorRangeForm()
        })
        .finally(() => {
          this.rangesLoading = false
        })
    },
    createDistributorRangeForm() {
      this.distributors.forEach((d) => {
        let distributor = {
          id: d.id,
          name: d.name,
          ranges: [],
        }
        this.ranges.map((rate) => {
          distributor.ranges.push({
            id: rate.id,
            range: rate.range,
            price: '0',
            priceFixedSalary: '0',
          })
        })
        this.distributorPrices.distributors.push(distributor)
      })
    },
    submit() {
      this.saving = true
      this.createSupplierProductPrice({
        supplierId: this.$route.params.supplierId,
        productId: this.$route.params.productId,
        type: this.$route.params.type,
        prices: this.distributorPrices,
      }).finally(() => {
        this.saving = false
        this.validSince = null
        this.distributorPrices.validSince = null
        this.distributorPrices.distributors = []
        this.createDistributorRangeForm()
        this.$emit('priceCreated')
        this.close()
      })
    },
    close() {
      this.dialog = false
    },
  },
}
</script>
